class StaffEditController {
	constructor(StaffFactory, MiscFactory, $rootScope, $filter, $state, $stateParams, ngDialog, URLS){
		'ngInject';
		const vm = this;

		vm.staffId = $stateParams.id;
		vm.rootScope = $rootScope;

		vm.$onInit = () => {
			vm.staff = {};
			if(vm.staffId){
				StaffFactory.getOne(vm.staffId).then(response => {
					vm.staff = response.data;
				});
			}
		};

		vm.submit = () => {
			if(vm.staff.id){
				/* UPDATE MATCH */
				StaffFactory.update(vm.staff.id, vm.staff).then(response => {
					ngDialog.open({template: 'successTemplate'});
					$state.reload();
				});
			}else{
				/* NEW MATCH */
				StaffFactory.create(vm.staff).then(response => {
					ngDialog.open({template: 'successTemplate'});
					$state.go('staff-edit', {id: response.data.id});
				});
			}
		};

		vm.getStaffImage = () =>{
			if(vm.staff.img){
				return URLS.IMAGES_URL + "/staff/" + vm.staff.img;
			}else{
				return 'assets/images/no_avatar.png';
			}
		};

		vm.goToProfile = () =>{
			$state.go('staff-profile',{id:vm.staffId});
		};
	}
}

export default StaffEditController;



// WEBPACK FOOTER //
// ./client/app/components/staff/staffEdit/staffEdit.controller.js